// extracted by mini-css-extract-plugin
export default {"card":"styles_card__gHvgd","list":"styles_list__ziM4T","title":"styles_title__uUHlf"};